export var global = {

    // urlgraph:'http://localhost:4001/graphql',
    // urlsocket:'http://localhost:4001/',
    // urlfront:'http://localhost:4200/',
    urlgraph:'https://api.mingobierno.gob.bo/sigrrhhapi',
    urlfront:'https://app.mingobierno.gob.bo/sigrrhh',
    urlsocket:'https://api.mingobierno.gob.bo',
    secret:'M1ng0B2o2l',

  }
